/* eslint no-prototype-builtins: "off" */

'use strict';

const jQuery = require('jquery');

const Container = require('./../../../../core/container');
const Translator = require('./../../../../core/translator');

const PopinManager = require('./../../../../services/popin');
const Notifier = require('./../../../../services/notifier');
const Zone = require('./../../../../services/structure/zone');
const GroupRepository = require('./../../repository/GroupRepository');
const BundleRepository = require('./../../../bundle/repository/BundleRepository');
const PageRepository = require('./../../../page/repository/page');
const FormBuilder = require('./../../../../services/form');
const ListItem = require('./../../../../services/listItem');
const Loader = require('./../../../../services/loader');

const ListTpl = require('./template/list.hbs');
const UsersTpl = require('./template/users.hbs');

const onRemoveUser = function(user, group) {
  let popin = PopinManager.createPopin({
    'title': Translator.translate('group_management_remove_user_modal'),
    'minHeight': 50,
    'buttons': [
      {
        class: 'popin popin-cancel',
        text: Translator.translate('discard'),
        click: function() {
          popin.hide();
        },
      },
      {
        text: Translator.translate('remove'),
        click: function() {
          GroupRepository.removeUser(group.id, user.id).done(() => {
            Notifier.success(Translator.translate('group_management_remove_user_confirmed'));
            showUsers(group);
          });

          popin.hide();
        },
      },
    ],
  });

  Container.set('prevent-hide-toolbar', true);
  Container.set('prevent-hide-overlay', true);
  popin.on('close', function() {
    setTimeout(function() {
      Container.set('prevent-hide-toolbar', false);
      Container.set('prevent-hide-overlay', false);
    }, 100);
  });

  let content = Translator.translate('group_management_remove_user_confirm', {
    userName: user.name,
    groupName: group.name,
  });

  popin.setContent(`<p>${content}</p>`);
  popin.display();
};

const onAddUser = function(user, group) {
  let popin = PopinManager.createPopin({
    'title': Translator.translate('add_user_to_the_group'),
    'minHeight': 50,
    'buttons': [
      {
        class: 'popin popin-cancel',
        text: Translator.translate('discard'),
        click: function() {
          popin.hide();
        },
      },
      {
        text: Translator.translate('add'),
        click: function() {
          GroupRepository.addUser(group.id, user.id).done(() => {
            Notifier.success(Translator.translate('group_management_add_user_confirmed'));
            showUsers(group);
          });

          popin.hide();
        },
      },
    ],
  });

  Container.set('prevent-hide-toolbar', true);
  Container.set('prevent-hide-overlay', true);
  popin.on('close', function() {
    setTimeout(function() {
      Container.set('prevent-hide-toolbar', false);
      Container.set('prevent-hide-overlay', false);
    }, 100);
  });

  let content = Translator.translate('group_management_add_user_confirm', {
    userName: user.name,
    groupName: group.name,
  });

  popin.setContent(`<p>${content}</p>`);
  popin.display();
};

const deleteGroup = (group) => {
  let popinConfig = {
    'title': Translator.translate('group_management_delete_group_modal'),
    'minHeight': 50,
    'buttons': [
      {
        class: 'popin popin-cancel',
        text: Translator.translate('discard'),
        click: function() {
          popin.hide();
        },
      },
      {
        text: Translator.translate(group['is_removable'] ? 'delete' : 'ok'),
        click: function() {
          if (group['is_removable']) {
            GroupRepository.delete(group.id).done(() => {
              Notifier.success(Translator.translate('group_management_delete_group_confirmed'));
              list();
            }).fail(() => {
              Notifier.warning(Translator.translate('group_management_cant_delete_group_with_users_message'));
            });
          }

          popin.hide();
        },
      },
    ],
  };

  if (!group['is_removable']) {
    popinConfig.buttons.shift();
  }

  let popin = PopinManager.createPopin(popinConfig);

  Container.set('prevent-hide-toolbar', true);
  Container.set('prevent-hide-overlay', true);
  popin.on('close', function() {
    setTimeout(function() {
      Container.set('prevent-hide-toolbar', false);
      Container.set('prevent-hide-overlay', false);
    }, 100);
  });

  let content;

  if (!group['is_removable']) {
    content = Translator.translate('group_management_cant_delete_group_confirm');
  } else {
    content = Translator.translate('group_management_delete_group_confirm', {
      groupName: group.name,
    });
  }

  popin.setContent(`<p>${content}</p>`);
  popin.display();
};

const list = (term) => {
  let $tpl = jQuery(ListTpl());
  let $list = $tpl.find('.group-list');
  let $searchInput = $tpl.find('input.input-search');
  const showGroups = (term = '') => {
    GroupRepository.findBy({term}).done((groups) => {
      $list.html('');
      groups.forEach((group) => {
        let btnConfig = {
          name: Translator.translate(group.name),
          buttons: [
            {
              iconClass: 'icon-pencil',
              onClick: function() {
                buildForm(group);
              },
            },
            {
              iconClass: 'icon-user',
              onClick: function() {
                showUsers(group);
              },
            },
          ],
        };

        if (!group['read_only']) {
          btnConfig.buttons.push({
            iconClass: 'icon-times',
            onClick: function() {
              deleteGroup(group);
            },
          });
        }

        $list.append(ListItem.create(btnConfig));
      });
    });
  };

  showGroups();

  $searchInput.on('keyup', function() {
    showGroups(jQuery.trim($searchInput.val().replace(/[\/\\"]/gi, ' ')).replace(/\s+/g, ' '));
  });

  Zone.setFullPanel(Translator.translate('group_management'), $tpl);
};

const showUsers = (group) => {
  let $tpl = jQuery(UsersTpl());

  GroupRepository.getUsers(group.id).done((users) => {
    let form = FormBuilder.getForm({
      elements: {
        users: {
          'type': 'searchList',
          'url_request': `/rest/2/user`,
          'label': Translator.translate('add_user_to_the_group'),
          'placeholder': Translator.translate('user_list'),
          'value': users,
          'itemWrapperLabel': Translator.translate('user_group_list'),
          'minLength': 0,
          'addItemOnSelect': false,
          'preventRemove': true,
          'termName': 'name',
          'wrap_class': 'cloud-group mt-3',
          'onMap': (item) => {
            item.name = item.firstname + ' ' + item.lastname;
            return {
              value: item.id,
              label: item.name,
              extra: item,
            };
          },
          'addItem': (data) => {
            let $item = ListItem.create({
              name: data.extra.name,
              buttons: [
                {
                  'iconClass': 'icon-times',
                  'onClick': function() {
                    onRemoveUser(data.extra, group);
                  },
                },
              ],
            });

            $item.attr('data-id', data.extra.id);

            return $item;
          },
          'onSelect': (item) => {
            onAddUser(item.extra, group);
          },
        },
      },
      form: {
        'submit_class': 'd-none',
      },
    });

    $tpl.find('.search-wrapper').append(form.render());
  });

  Zone.setFullPanel(Translator.translate('group_management_users_title', {name: Translator.translate(group.name)}), $tpl);
};

const buildForm = (groupData = null, refresh) => {
  let $container = jQuery('<div />');
  let data = groupData || {
    'features_rights': [],
    'pages_rights': {'rights': [], 'page_types': [], 'categories': []},
  };
  let isReadOnly = !!data['read_only'];

  if (isReadOnly) {
    $container.append(`<p class="error">${Translator.translate('group_management_group_not_updatable')}</p>`);
  }

  Loader.start($container);

  GroupRepository.findBy({term: ''}).done((groupsType) => {
    PageRepository.getCategories().done((pageCategories) => {
      PageRepository.getTypes('right').done((pageTypes) => {
        let config = {
          'elements': {
            'name': {
              'type': 'text',
              'value': data.name || '',
              'element_class': 'cloud-control form-control',
              'disabled': isReadOnly,
              'group': {
                'id': 'name-group',
                'title': Translator.translate('group_management_group_name'),
              },
            },
            'description': {
              'type': 'textarea',
              'value': data.description || '',
              'element_class': 'cloud-control form-control',
              'disabled': isReadOnly,
              'group': {
                'id': 'description-group',
                'title': Translator.translate('group_management_group_description'),
              },
            },
            'group_asset': {
              'type': 'select',
              'defaultOption': Translator.translate('choose_group_asset'),
              'options': function() {
                let options = {};

                groupsType.forEach((group) => {
                  if (group.id !== 'admin') {
                    options[group.id] = group.name;
                  }
                });

                return options;
              }(),
              'onChange': function(e) {
                let $select = jQuery(e.currentTarget);
                let option = $select.find('option:selected').val();

                if (option !== 'backbee-default') {
                  let group = groupsType.find((current) => {
                    return current.id === option;
                  });

                  if (group) {
                    let $form = $select.parents('form');

                    buildForm({
                      'name': $form.find('input[name="name"]').val(),
                      'description': $form.find('textarea[name="description"]').val(),
                      'features_rights': group['features_rights'],
                      'pages_rights': group['pages_rights'],
                      'group_asset': option,
                    }, false);
                  }
                }
              },
              'value': data['group_asset'] || '',
              'group': {
                id: 'global',
              },
            },
            'SEO_TRACKING_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('analytics_seo_tools'),
              'value': data['features_rights'].includes('SEO_TRACKING_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'TAG_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('tag_management'),
              'value': data['features_rights'].includes('TAG_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'MULTILANG_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('lang_management'),
              'value': data['features_rights'].includes('MULTILANG_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'CUSTOM_DESIGN_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('design_settings'),
              'value': data['features_rights'].includes('CUSTOM_DESIGN_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'PRIVACY_POLICY_FEATURE': {
              'type': 'checkbox',
              'label': 'Politique de confidentialité',
              'value': data['features_rights'].includes('PRIVACY_POLICY_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'GLOBAL_CONTENT_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('global_content_settings'),
              'value': data['features_rights'].includes('GLOBAL_CONTENT_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'USER_RIGHT_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('user_group'),
              'value': !data.id ? false : data['features_rights'].includes('USER_RIGHT_FEATURE'),
              'disabled': true,
              'tooltip': Translator.translate('user_right_feature_tooltip'),
              'onClick': function() {
                form.addError('USER_RIGHT_FEATURE', Translator.translate('user_right_feature_tooltip'));
                form.displayErrors();
              },
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'BUNDLE_MEDIACENTER_FEATURE': {
              'type': 'checkbox',
              'label': Translator.translate('bundle_mediacenter_settings'),
              'value': data['features_rights'].includes('BUNDLE_MEDIACENTER_FEATURE'),
              'disabled': isReadOnly,
              'group': {
                id: 'global',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'ONLINE_PAGE_EDIT': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_parameter_management_page'),
              'value': data['pages_rights']['rights'].includes('ONLINE_PAGE_EDIT'),
              'disabled': isReadOnly,
              'group': {
                id: 'online',
                title: Translator.translate('group_management_online_page'),
              },
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');
                $form.find('input[name="ONLINE_PAGE_PUBLISH"]').prop('checked', value);
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'ONLINE_PAGE_DELETE': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_delete_page'),
              'value': data['pages_rights']['rights'].includes('ONLINE_PAGE_DELETE'),
              'disabled': isReadOnly,
              'group': {
                id: 'online',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'ONLINE_PAGE_PUBLISH': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_put_offline'),
              'value': data['pages_rights']['rights'].includes('ONLINE_PAGE_PUBLISH'),
              'disabled': isReadOnly,
              'group': {
                id: 'online',
              },
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');
                $form.find('input[name="ONLINE_PAGE_EDIT"]').prop('checked', value);
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'ONLINE_PAGE_CREATE_CONTENT': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_block_management_draft'),
              'value': data['pages_rights']['rights'].includes('ONLINE_PAGE_CREATE_CONTENT'),
              'disabled': isReadOnly,
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');

                $form.find('input[name="ONLINE_PAGE_EDIT_CONTENT"]').prop('checked', value);
              },
              'group': {
                id: 'online',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'ONLINE_PAGE_EDIT_CONTENT': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_set_content_text_image_draft'),
              'value': data['pages_rights']['rights'].includes('ONLINE_PAGE_EDIT_CONTENT'),
              'disabled': isReadOnly,
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');

                if (!value) {
                  $form.find('input[name="ONLINE_PAGE_CREATE_CONTENT"]').prop('checked', false);
                }
              },
              'group': {
                id: 'online',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'OFFLINE_PAGE_CREATE': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_create_page'),
              'value': data['pages_rights']['rights'].includes('OFFLINE_PAGE_CREATE'),
              'disabled': isReadOnly,
              'group': {
                id: 'offline',
                title: Translator.translate('group_management_offline_page'),
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'OFFLINE_PAGE_EDIT': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_parameter_management_page'),
              'value': data['pages_rights']['rights'].includes('OFFLINE_PAGE_EDIT'),
              'disabled': isReadOnly,
              'group': {
                id: 'offline',
              },
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');
                $form.find('input[name="OFFLINE_PAGE_PUBLISH"]').prop('checked', value);
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'OFFLINE_PAGE_DELETE': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_delete_page'),
              'value': data['pages_rights']['rights'].includes('OFFLINE_PAGE_DELETE'),
              'disabled': isReadOnly,
              'group': {
                id: 'offline',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'OFFLINE_PAGE_PUBLISH': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_put_online'),
              'value': data['pages_rights']['rights'].includes('OFFLINE_PAGE_PUBLISH'),
              'disabled': isReadOnly,
              'group': {
                id: 'offline',
              },
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');
                $form.find('input[name="OFFLINE_PAGE_EDIT"]').prop('checked', value);
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'OFFLINE_PAGE_CREATE_CONTENT': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_block_management_draft'),
              'value': data['pages_rights']['rights'].includes('OFFLINE_PAGE_CREATE_CONTENT'),
              'disabled': isReadOnly,
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');

                $form.find('input[name="OFFLINE_PAGE_EDIT_CONTENT"]').prop('checked', value);
              },
              'group': {
                id: 'offline',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
            'OFFLINE_PAGE_EDIT_CONTENT': {
              'type': 'checkbox',
              'label': Translator.translate('group_management_set_content_text_image'),
              'value': data['pages_rights']['rights'].includes('OFFLINE_PAGE_EDIT_CONTENT'),
              'disabled': isReadOnly,
              'onChange': function(e) {
                let $checkbox = jQuery(e.currentTarget);
                let $form = $checkbox.parents('form');
                let value = $checkbox.prop('checked');

                if (!value) {
                  $form.find('input[name="OFFLINE_PAGE_CREATE_CONTENT"]').prop('checked', false);
                }
              },
              'group': {
                id: 'offline',
              },
              'wrap_class': 'cloud-group mb-0',
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
            },
          },
          'form': {
            'submit_class': isReadOnly ? 'd-none' : 'btn btn-primary mt-3 ml-3',
            'submit_label': Translator.translate('save'),
          },
        };

        Loader.stop($container);

        if (data.id) {
          delete config.elements['group_asset'];
        }

        if (!Container.get('multi-language')) {
          delete config.elements['MULTILANG_FEATURE'];
        }

        BundleRepository.findAll().done((bundles) => {
          bundles.forEach((bundle, key) => {
            let elementName = `BUNDLE_${bundle.id}_FEATURE`;
            let group = {
              id: 'extension',
            };

            if (!key) {
              group.title = Translator.translate('group_management_extensions');
            }

            config.elements[elementName] = {
              'type': 'checkbox',
              'label': bundle.name || Translator.translate(`bundle_${bundle.id}`),
              'value': data['features_rights'].includes(elementName),
              'disabled': isReadOnly,
              group,
              'label_class': 'cloud-form-control cloud-checkbox mb-0',
              'wrap_class': 'cloud-group mb-0',
            };
          });
        });

        let noPageTypesSelected = data['pages_rights']['page_types'][0] === 'all';

        if (pageTypes.length) {
          config.elements['all_page_types'] = {
            'type': 'checkbox',
            'label': Translator.translate('all_page_types'),
            'value': noPageTypesSelected,
            'disabled': isReadOnly,
            'label_class': 'font-weight-bold cloud-form-control cloud-checkbox underline mb-0',
            'group': {
              id: 'page_type',
            },
            'onChange': function(e) {
              let $checkbox = jQuery(e.currentTarget);
              let $form = $checkbox.parents('form:first');
              let $group = $form.children('.page_type ');
              let isChecked = $checkbox.prop('checked');
              let $allCheckboxGroup = $group.find('.cloud-group:not(.element_all_page_types)');

              $allCheckboxGroup[isChecked ? 'addClass' : 'removeClass']('d-none');

              if (isChecked) {
                $allCheckboxGroup.find('input[type="checkbox"]').prop('checked', false);
              }

              onHandlePageType();
            },
            'wrap_class': 'cloud-group mb-0',
          };
        }

        pageTypes.forEach((pageType, key) => {
          let elementName = `PAGE_TYPE_${pageType['unique_name']}`;
          let group = {
            id: 'page_type',
          };

          if (!key) {
            group.title = Translator.translate('group_management_page_type');
          }

          config.elements[elementName] = {
            'type': 'checkbox',
            'label': Translator.translate(Translator.translate(`page_type_${pageType['unique_name']}`) === `page_type_${pageType['unique_name']}` ? `new_page_${pageType['unique_name']}` : `page_type_${pageType.unique_name}`),
            'disabled': isReadOnly,
            'value': data['pages_rights']['page_types'].includes(pageType['unique_name']),
            group,
            'wrap_class': 'mb-0 cloud-group ' + (noPageTypesSelected ? 'd-none' : ''),
            'label_class': 'cloud-form-control cloud-checkbox mb-0',
            'onChange': function() {
              onHandlePageType();
            },
          };
        });

        let noCategoriesSelected = data['pages_rights']['categories'][0] === 'all';

        if (pageCategories.length) {
          config.elements['all_page_categories'] = {
            'type': 'checkbox',
            'label': Translator.translate('all_page_categories'),
            'value': noCategoriesSelected,
            'disabled': isReadOnly,
            'label_class': 'font-weight-bold cloud-form-control cloud-checkbox underline mb-0',
            'group': {
              id: 'page_categories',
            },
            'onChange': function(e) {
              let $checkbox = jQuery(e.currentTarget);
              let $form = $checkbox.parents('form:first');
              let $group = $form.children('.page_categories ');
              let isChecked = $checkbox.prop('checked');
              let $allCheckboxGroup = $group.find('.cloud-group:not(.element_all_page_categories)');

              $allCheckboxGroup[isChecked ? 'addClass' : 'removeClass']('d-none');

              if (isChecked) {
                $allCheckboxGroup.find('input[type="checkbox"]').prop('checked', false);
              }
            },
            'wrap_class': 'cloud-group mb-0',
          };
        }
        pageCategories.forEach((pageCategory, key) => {
          let elementName = `PAGE_CATEGORY_${pageCategory}`;
          let group = {
            id: 'page_categories',
          };

          if (!key) {
            group.title = Translator.translate('group_management_page_categories');
          }

          config.elements[elementName] = {
            'type': 'checkbox',
            'label': Translator.translate(`page_category_${pageCategory}`),
            'disabled': isReadOnly,
            'value': data['pages_rights']['categories'].includes(pageCategory),
            group,
            'wrap_class': 'mb-0 cloud-group ' + (noCategoriesSelected ? 'd-none' : ''),
            'label_class': 'cloud-form-control cloud-checkbox mb-0',
          };
        });

        let form = FormBuilder.getForm(config);

        const buildFeatureRights = (submitData) => {
          let rights = [];

          for (let key in submitData) {
            if (submitData.hasOwnProperty(key)) {
              let value = submitData[key];

              if (key.includes('FEATURE')) {
                if (value === true) {
                  rights.push(key);
                }
              }
            }
          }

          return rights;
        };

        const buildPageRights = (submitData) => {
          let rights = {'online_page': [], 'offline_page': [], 'page_types': [], 'categories': []};

          for (let key in submitData) {
            if (submitData.hasOwnProperty(key)) {
              let value = submitData[key];
              let rightName;

              if (key.includes('ONLINE_PAGE')) {
                rightName = key.replace('ONLINE_PAGE_', '');
                if (value === true) {
                  rights['online_page'].push(rightName);

                  if (rightName === 'CREATE_CONTENT') {
                    rights['online_page'].push('DELETE_CONTENT');
                  }
                }
              } else if (key.includes('OFFLINE_PAGE')) {
                rightName = key.replace('OFFLINE_PAGE_', '');
                if (value === true) {
                  rights['offline_page'].push(rightName);

                  if (rightName === 'CREATE_CONTENT') {
                    rights['offline_page'].push('DELETE_CONTENT');
                  }
                }
              } else if (key.includes('PAGE_TYPE')) {
                rightName = key.replace('PAGE_TYPE_', '');
                if (value === true) {
                  rights['page_types'].push(rightName);
                }
              } else if (key.includes('PAGE_CATEGORY')) {
                rightName = key.replace('PAGE_CATEGORY_', '');
                if (value === true) {
                  rights['categories'].push(rightName);
                }
              }
            }
          }

          return rights;
        };

        const buildAvailableData = (submitData) => {
          return {
            'name': submitData.name,
            'description': submitData.description,
            'features_rights': buildFeatureRights(submitData),
            'pages_rights': buildPageRights(submitData),
          };
        };

        form.on('validate', (submitData) => {
          if (!submitData.name) {
            form.addError('name', Translator.translate('name_group_required'));
            jQuery('.cloud-panel-fullpage').scrollTop(0);
          }
        });

        form.on('submit', (submitData) => {
          let sendData = buildAvailableData(submitData);

          if (submitData['all_page_types']) {
            sendData['pages_rights']['page_types'] = ['all'];
          }

          if (submitData['all_page_categories']) {
            sendData['pages_rights']['categories'] = ['all'];
          }

          GroupRepository.save(sendData, data.id).done(function() {
            Notifier.success(Translator.translate('recorded'));
            list();
          }).fail(() => {
            form.addError('name', Translator.translate('group_already_exist'));
            form.displayErrors();
            jQuery('.cloud-panel-fullpage').scrollTop(0);
          });
        });

        $container.append(form.render());

        let onHandlePageType = () => {
          let $selectedPageType = form.$.find('.page_type input[type="checkbox"]:checked').length > 0;
          let $inputOffline = form.$.find('.offline input[type="checkbox"]');
          let $labelGroupOffline = form.$.find('.offline label.group-label');
          let $inputOnline = form.$.find('.online input[type="checkbox"]');
          let $labelGroupOnline = form.$.find('.online label.group-label');

          if (!$selectedPageType && $labelGroupOffline.next('span').length === 0 && $labelGroupOnline.next('span').length === 0) {
            $labelGroupOffline.after('<span class="error">' + Translator.translate('group_management_no_page_type_selected_tooltip') + '</span>');
            $labelGroupOnline.after('<span class="error">' + Translator.translate('group_management_no_page_type_selected_tooltip') + '</span>');
          } else {
            $labelGroupOffline.next('span').remove();
            $labelGroupOnline.next('span').remove();
          }

          $inputOffline.prop('disabled', !$selectedPageType);
          $inputOnline.prop('disabled', !$selectedPageType);

          if (!$selectedPageType) {
            $inputOffline.prop('checked', false);
            $inputOnline.prop('checked', false);
          }
        };

        onHandlePageType();
      });
    });
  });

  Zone.setFullPanel(Translator.translate(`group_${data.id ? 'edit' : 'add'}`), $container);
};

module.exports.list = list;
module.exports.createGroup = buildForm;
